import { render, staticRenderFns } from "./PedidoIngresado.vue?vue&type=template&id=ae6b3c40&scoped=true"
import script from "./PedidoIngresado.vue?vue&type=script&lang=js"
export * from "./PedidoIngresado.vue?vue&type=script&lang=js"
import style0 from "./PedidoIngresado.vue?vue&type=style&index=0&id=ae6b3c40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6b3c40",
  null
  
)

export default component.exports